<template>
  <div>
    <!-- 配送单统计 -->
    <h3>
      {{ $t('message.deliveryOrderStatistics') }}
      <el-button type="text" @click="isDetail = !isDetail" class="fr">
        {{ isDetail ? '详情>>' : '<<返回' }} </el-button>
    </h3>
    <div class="deliveryNoteInformation" v-show="isDetail">
      <div class="orderStatistics">
        <!-- 配送单数量 -->
        <div class="item">
          <div>
            {{ $t('message.numberOfDeliveryOrders') }}
            <div class="num">{{ orderStatistics.porderNumber }}</div>
          </div>
        </div>
        <!--出货金额  -->
        <div class="item">
          <div>
            {{ $t('message.orderAmount') }}
            <div class="num">{{ orderStatistics.shipmentAmount }} ¥</div>
          </div>
        </div>
        <!--国际运费  -->
        <div class="item">
          <div>
            {{ $t('message.internationalFreight') }}
            <div class="num">{{ orderStatistics.logisticsExpense }} ¥</div>
          </div>
        </div>
        <!-- 节省金额 -->
        <div class="item">
          <div>
            {{ $t('message.saveMoney') }}
            <div class="num">{{ orderStatistics.favorableAmount }} ¥</div>
          </div>
        </div>
      </div>
      <!-- 订单统计 -->
      <h3>
        <el-date-picker v-model="time" type="datetimerange" range-separator="至" value-format="yyyy-MM-dd HH:mm:ss"
          :default-time="['00:00:00', '23:59:59']" start-placeholder="开始日期" end-placeholder="结束日期" @change="setData">
        </el-date-picker>
      </h3>
      <!-- 图表-->
      <div class="chart">
        <div class="item">
          <h4>运输方式</h4>
          <echarts :option="optionData.logistics" v-if="optionData.logisticsShow" />
        </div>
        <div class="item">
          <h4>各阶段纳期占比</h4>
          <echarts :option="optionData.naageScale" v-if="optionData.naageScaleShow" />
        </div>
      </div>
      <!-- 图表-->
      <div class="chart">
        <div class="item">
          <h4>运输重量</h4>
          <echarts :option="optionData.weight" v-if="optionData.weightShow" />
        </div>
        <div class="item">
        </div>
      </div>
    </div>

    <!-- 详情列表-->
    <div class="detail" v-show="!isDetail">
      <div class="table">
        <ol>
          <li class="flex05">NO</li>
          <!-- 配送单号 -->
          <li> {{ $t('message.deliveryNoteNumber') }}</li>
          <!-- 出货金额（元） -->
          <li> {{ $t('message.shipmentAmountY') }}</li>
          <!-- 配送方式 -->
          <li> {{ $t('message.deliveryMethod') }}</li>
          <!-- 状态 -->
          <li> {{ $t('message.status') }}</li>
          <!-- 提出时间 -->
          <li> {{ $t('message.forwardTime') }}</li>
          <!-- 签收时间 -->
          <li> {{ $t('message.signForTime') }}</li>
          <!-- 国际运费（元） -->
          <li> {{ $t('message.internationalFreight') }}（元）</li>
          <!-- 订单纳期 -->
          <li> {{ $t('message.orderDeliveryTime') }}</li>
          <!-- 详细 -->
          <li class="flex05"> {{ $t('message.detail') }}</li>
        </ol>
        <ul v-for="(item, index) in tableData" :key="index">
          <li class="flex05">{{ item.rowNumber }}</li>
          <!-- 配送单号 -->
          <li>
            <router-link :to="'/porderDetail?porder_sn=' + item.porder_sn" target="_blank" class="a-link">
              {{ item.porder_sn }}
            </router-link>
          </li>
          <!-- 出货金额（元） -->
          <li> {{ item.shipment_amount }}</li>
          <!-- 配送方式 -->
          <li>
            <p v-for="(items) in item.transmit_mode">
              {{ items }}
            </p>
          </li>
          <!-- 状态 -->
          <li> {{ item.status }}</li>
          <!-- 提出时间 -->
          <li> {{ item.created_at }}</li>
          <!-- 签收时间 -->
          <li> {{ item.datetime_client_receive }}</li>
          <!-- 国际运费（元） -->
          <li> {{ item.logistics_price }}</li>
          <!-- 订单纳期 -->
          <li> {{ item.naage }}</li>
          <!-- 详细 -->
          <li class="flex05">
            <el-popover placement="left" :title="$t('message.detail')" trigger="click">
              <el-table :data="structure" border>
                <el-table-column width="100" label="类型" align="center">
                  <template slot-scope="scope">
                    纳期（天）
                  </template>
                </el-table-column>
                <el-table-column width="100" label="翻译" align="center">
                  <template slot-scope="scope">
                    {{ scope.row.datetime_translate ? scope.row.datetime_translate : '--' }}
                  </template>
                </el-table-column>
                <el-table-column width="100" label="报价" align="center">
                  <template slot-scope="scope">
                    {{ scope.row.datetime_offer ? scope.row.datetime_offer : '--' }}
                  </template>
                </el-table-column>
                <el-table-column width="100" label="入金" align="center">
                  <template slot-scope="scope">
                    {{ scope.row.datetime_pay_submit ? scope.row.datetime_pay_submit : '--' }}
                  </template>
                </el-table-column>
                <el-table-column width="100" label="确认入金" align="center">
                  <template slot-scope="scope">
                    {{ scope.row.datetime_pay_confirm ? scope.row.datetime_pay_confirm : '--' }}
                  </template>
                </el-table-column>
                <el-table-column width="100" label="出货" align="center">
                  <template slot-scope="scope">
                    {{ scope.row.datetime_delivery ? scope.row.datetime_delivery : '--' }}
                  </template>
                </el-table-column>
                <el-table-column width="100" label="签收" align="center">
                  <template slot-scope="scope">
                    {{ scope.row.datetime_client_receive ? scope.row.datetime_client_receive : '--' }}
                  </template>
                </el-table-column>
                <el-table-column width="100" label="总纳期" align="center" prop="datetime_total">
                </el-table-column>
              </el-table>
              <el-table :data="porder_freight" border style="margin: 24px 0; width: 702px;">
                <el-table-column width="100" label="运输方式" align="center" prop="logistics">
                </el-table-column>
                <el-table-column width="100" label="抛重" align="center" prop="bubble_weight">
                </el-table-column>
                <el-table-column width="100" label="提出数量（件）" align="center" prop="logistics_number">
                </el-table-column>
                <el-table-column width="100" label="出货金额（元）" align="center" prop="shipment_amount">
                </el-table-column>
                <el-table-column width="100" label="国际运费（元）" align="center" prop="logistics_cost">
                </el-table-column>
                <el-table-column width="100" label="提出时间" align="center">
                  <template slot-scope="scope">
                    {{ scope.row.recurring_date ? scope.row.recurring_date : '--' }}
                  </template>
                </el-table-column>
                <el-table-column width="100" label="签收时间" align="center">
                  <template slot-scope="scope">
                    {{ scope.row.datetime_client_receive ? scope.row.datetime_client_receive : '--' }}
                  </template>
                </el-table-column>
              </el-table>
              <el-button type="text" slot="reference" @click="userPorderDetail(item.porder_sn)"> {{
                $t('message.look')
              }}</el-button>
            </el-popover>
          </li>
        </ul>
      </div>
      <!-- 分页 -->
      <div class="paginationContainer">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="datas.page"
          :page-sizes="[10, 20, 50, 100]" :page-size="datas.pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import { pieOption, option } from '@/utlis/echartsOption'
import { getDate, lessThanAMonth } from '@/utlis/date'
export default {
  data() {
    return {
      pieOption,
      isDetail: true,
      orderStatistics: {},
      user_id: this.$route.query.userID,
      datas: {
        page: 1,
        pageSize: 10,
        user_id: this.$route.query.userID,
      },
      total: 0,
      tableData: [],
      time: [lessThanAMonth(getDate()), getDate(),],
      optionData: {
        logistics: {},
        logisticsShow: false,
        naageScale: {},
        naageScaleShow: false,
        weight: {},
        weightShow: false
      },
      logisticsData: {
        user_id: this.$route.query.userID,
      },
      structure: [],
      porder_freight: [],
    };
  },
  created() {
    this.userPorderStatistics()
    this.userPorderList()
    this.logisticsModeStatistics()
    this.naageScale()
    this.transportWeight()
  },
  methods: {
    userPorderStatistics() {
      this.$api.clienteleApi.userPorderStatistics({ user_id: this.user_id }).then((res) => {
        this.orderStatistics = res.data
      });
    },
    userPorderList() {
      this.$api.clienteleApi.userPorderList(this.datas).then((res) => {
        this.tableData = res.data.data
        this.total = res.data.total
      });
    },
    // 分页
    handleCurrentChange(val) {
      this.datas.page = val;
      this.userPorderList();
    },
    handleSizeChange(val) {
      this.datas.pageSize = val;
      this.userPorderList();
    },
    // 客户运输方式统计
    logisticsModeStatistics() {
      if (this.time != false) {
        this.logisticsData.start_time = this.time[0]
        this.logisticsData.end_time = this.time[1]
      } else {
        this.logisticsData.start_time = ''
        this.logisticsData.end_time = ''
      }
      this.$api.clienteleApi.logisticsModeStatistics(this.logisticsData).then((res) => {
        this.setLogistics(res.data)
      });
    },
    // 客户运输方式统计
    setLogistics(data) {
      this.optionData.logistics = {
        title: {

        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['箱数', '运输次数'],
          icon: 'circle',
          left: '5%',
          top: 0
        },
        grid: {
          left: '0%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        // toolbox: {
        //   feature: {
        //     saveAsImage: {}
        //   }
        // },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: []
        },
        yAxis: {
          type: 'value',
          axisLine: { lineStyle: { color: "#999" }, show: false },
          show: true
        },
        series: [
          {
            name: '箱数',
            type: 'bar',
            stack: 'Total',
            itemStyle: {
              barBorderRadius: [3, 3, 0, 0]
            },
            barWidth: 8,
            data: []
          }, {
            name: '运输次数',
            type: 'line',
            stack: 'Total',
            data: []
          }
        ]
      }
      data.forEach(item => {
        this.optionData.logistics.series[0].data.push(item.value)
        this.optionData.logistics.series[1].data.push(item.frequency)
        this.optionData.logistics.xAxis.data.push(item.logistics_name)
      })
      this.optionData.logisticsShow = true
      this.$forceUpdate()
    },
    //客户纳期占比
    naageScale() {
      if (this.time != false) {
        this.logisticsData.start_time = this.time[0]
        this.logisticsData.end_time = this.time[1]
      } else {
        this.logisticsData.start_time = ''
        this.logisticsData.end_time = ''
      }
      this.$api.clienteleApi.naageScale(this.logisticsData).then((res) => {
        this.setPieEcharts(res.data)
      });
    },
    // 饼图
    setPieEcharts(data) {
      this.optionData.naageScale = JSON.parse(JSON.stringify(this.pieOption)) // 复制模板
      this.optionData.naageScale.legend = {
        orient: 'vertical',
        right: 10,
        bottom: 10,
        data: [],
        icon: 'circle',
      }
      this.optionData.naageScale.tooltip.formatter = '{a} <br/>{b}: {c} ({d}%)'
      this.optionData.naageScale.series = [
        {
          name: '消费比率',
          type: 'pie',
          radius: ['50%', '85%'],
          avoidLabelOverlap: false,
          label: {
            normal: {
              show: true,
              color: '#4c4a4a',
            },
          },
          emphasis: {
            label: {
              show: true,
              fontSize: '30',
              fontWeight: 'bold'
            },
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          },
          labelLine: {
            show: true
          },
          data: []
        }
      ]
      // let itemData = this.datas.data.find(item => item.k == this.datas.years)

      data.forEach((item, i) => {
        this.optionData.naageScale.legend.data.push(item.name)
        this.optionData.naageScale.series[0].data.push(
          { value: item.value, name: item.name },
        )
      })
      this.optionData.naageScaleShow = true
    },
    //客户运输重量
    transportWeight() {
      if (this.time != false) {
        this.logisticsData.start_time = this.time[0]
        this.logisticsData.end_time = this.time[1]
      } else {
        this.logisticsData.start_time = ''
        this.logisticsData.end_time = ''
      }
      this.$api.clienteleApi.transportWeight(this.logisticsData).then((res) => {
        this.setWeight(res.data)
      });
    },
    //客户运输重量
    setWeight(data) {
      this.optionData.weight = {
        title: {

        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['实际重量', '计费重量'],
          icon: 'circle',
          left: '5%',
          top: 0
        },
        grid: {
          left: '0%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        // toolbox: {
        //   feature: {
        //     saveAsImage: {}
        //   }
        // },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: []
        },
        yAxis: {
          type: 'value',
          axisLine: { lineStyle: { color: "#999" }, show: false },
          show: true
        },
        series: [
          {
            name: '实际重量',
            type: 'bar',
            // stack: 'Total',
            itemStyle: {
              barBorderRadius: [3, 3, 0, 0]
            },
            barWidth: 8,
            data: []
          }, {
            name: '计费重量',
            type: 'bar',
            // stack: 'Total',
            data: [],
            itemStyle: {
              barBorderRadius: [3, 3, 0, 0]
            },
            barWidth: 8,
          }
        ]
      }
      data.forEach(item => {
        this.optionData.weight.series[0].data.push(item.actual_weight)
        this.optionData.weight.series[1].data.push(item.charged_weight)
        this.optionData.weight.xAxis.data.push(item.logistics_name)
      })
      this.optionData.weightShow = true
      this.$forceUpdate()
    },
    // 重设数据
    setData() {
      this.optionData.logisticsShow = false
      this.optionData.naageScaleShow = false
      this.optionData.weightShow = false
      this.logisticsModeStatistics()
      this.naageScale()
      this.transportWeight()
    },
    //客户配送单详情
    userPorderDetail(porder_sn) {
      this.structure = []
      this.porder_freight = []
      this.$api.clienteleApi.userPorderDetail({ porder_sn }).then((res) => {
        this.structure.push(res.data.structure)
        this.porder_freight = res.data.porder_freight
      });
    },
  }
}
</script>
<style lang='scss' scoped>
h3 {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 24px;
}

.orderStatistics {
  display: flex;
  margin: 24px 0;

  .item {
    flex: 1;
    margin-right: 48px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 24px;
    background-color: #fff;
    text-align: center;
    font-size: 18px;
    border-radius: 5px;

    &:nth-last-child(1) {
      margin: 0;
    }

    .num {
      margin-top: 6px;
      color: #b4272d;
    }
  }
}

.table {
  .flex05 {
    flex: 0.5;
  }
}

.paginationContainer {
  text-align: center;
  padding: 24px 0;
}

.chart {
  display: flex;
  flex-wrap: wrap;

  .item {
    width: 48%;
    margin-right: 20px;


    h4 {
      margin: 20px 0;
      font-size: 18px;
    }

    &:nth-child(2n) {
      margin-right: 0;
    }
  }
}
</style>